import Error from '../../../model/Error';
import Offering from '../../../dto/offering/Offering';
import axios from 'axios';

export default class TrainingOfferingRepository {
    static find(offeringId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/training-offerings/${offeringId}`)
                .then((response) => resolve(Offering.fromData(response.data.data)))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static create(offering, clubId) {
        const offeringData = Object.assign({}, offering);
        offeringData.bookableForAdults = true;
        offeringData.bookableForNonAdults = true;

        if (offering.minimumAge) {
            offeringData.minimumAge = Number.parseInt(offering.minimumAge);
        }
        if (offering.maximumAge) {
            offeringData.maximumAge = Number.parseInt(offering.maximumAge);
        }

        if (offeringData.minimumAge === '') {
            offeringData.minimumAge = null;
        }
        if (offeringData.maximumAge === '') {
            offeringData.maximumAge = null;
        }

        if (offering.executionType) {
            offeringData.executionType = offering.executionType.value;
        }

        if (offering.sport) {
            offeringData.sportId = offering.sport.id;
            delete offeringData.sport;
        }

        if (offering.fields) {
            offeringData.fieldIds = offering.fields.map((field) => field.id);
            delete offeringData.fields;
        }

        if (offering.departments) {
            offeringData.bookableDepartmentIds = offering.departments.map((department) => department.id);
            delete offeringData.departments;
        }

        if (offering.teams) {
            offeringData.bookableTeamIds = offering.teams.map((team) => team.id);
            delete offeringData.teams;
        }

        if (offering.instructors) {
            offeringData.instructorIds = offering.instructors.map((instructor) => instructor.id);
            delete offeringData.instructors;
        }

        if (offering.isDeclinationRequired()) {
            offeringData.minParticipants = null;
            offeringData.maxParticipants = null;
        }

        return new Promise((resolve, reject) => {
            axios
                .post(`/club/clubs/${clubId}/training-offerings`, offeringData)
                .then((response) => resolve(response.headers.location))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static update(offering) {
        const offeringData = Object.assign({}, offering);

        if (offeringData.minimumAge) {
            offeringData.minimumAge = Number.parseInt(offering.minimumAge);
        }
        if (offeringData.maximumAge) {
            offeringData.maximumAge = Number.parseInt(offering.maximumAge);
        }

        if (offeringData.minimumAge === '') {
            offeringData.minimumAge = null;
        }
        if (offeringData.maximumAge === '') {
            offeringData.maximumAge = null;
        }

        if (offeringData.executionType) {
            offeringData.executionType = offering.executionType.value;
        }

        if (offeringData.sport) {
            offeringData.sportId = offering.sport.id;
            delete offeringData.sport;
        }

        if (offeringData.fields) {
            offeringData.fieldIds = offering.fields.map((field) => field.id);
            delete offeringData.fields;
        }

        if (offeringData.departments) {
            offeringData.bookableDepartmentIds = offering.departments.map((department) => department.id);
            delete offeringData.departments;
        }

        if (offeringData.teams) {
            offeringData.bookableTeamIds = offering.teams.map((team) => team.id);
            delete offeringData.teams;
        }

        if (offeringData.instructors) {
            offeringData.instructorIds = offering.instructors.map((instructor) => instructor.id);
            delete offeringData.instructors;
        }

        if (offering.isDeclinationRequired()) {
            offeringData.minParticipants = null;
            offeringData.maxParticipants = null;
        }

        return new Promise((resolve, reject) => {
            axios
                .put(`/club/training-offerings/${offeringData.id}`, offeringData)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
